import Packery from 'packery';
import Clipboard from 'clipboard';
import { ActivityStrategy } from '../../../shared/constants';
import PackUtils from '../../../shared/util/pack-utils';

import shared, {
    config, isLoggedIn, showSignInModal,
    trackEvent, getSubjectAreaPath,
} from '../../../shared/shared';
import i18n from '../../../shared/i18n/i18n';
import Sticky from '../../../shared/util/sticky';
import MediaGallery from '../../../shared/gallery/media-gallery';

import packDisplayShared from '../../../shared/pack-shared';
import CalendarModal from '../../../shared/widget/calendar-modal';
import QuickAssignActivity from '../../../shared/components/quick-assign-activity-modal';
import {ActivityRoute, LearningStrategySnackRoute, PackRoute} from '../../../shared/util/route-constants';
import OnboardingCard from '../../../shared/widget/onboarding/onboarding-card';
import { accountLevelPinboardFeatures } from '../../../shared/widget/onboarding/onboarding-card-features';
import Api from '../../../shared/api';
import { Country, OnboardingFeatureType, TypeIcons } from '../../../shared/constants';
import AjaxUtils from "../../../shared/util/ajax-utils";
import { initTooltips } from '../../../shared/util/dom';


const subjectPath = shared.getSubjectAreaPath();

const packDisplayActivitiesType = (function () {
    const customPackDetail = ko.observable();

    let _data,
        getSessionVar,
        setSessionVar;

    const localizedResource = i18n.resource;
    const localizedString = i18n.string;

    let mediaOverlayOpen = false;

    const ebNoteVisible = ko.observable(true);
    const userNoteVisible = ko.observable(true);
    const activityType = ko.observable({});

    ebNoteVisible.subscribe(layout);
    userNoteVisible.subscribe(layout);

    var gradeRanges = localizedResource('my.content.grade.ranges');
    const typeIcons = TypeIcons;
    const type = ko.observable('');
    const items = ko.observable({});
    const info = ko.observable({});
    const shortUrl = ko.observable('');
    const copying = ko.observable(false);
    const animate = ko.observable(true);
    const focus = ko.observable(null);
    const printUrl = ko.observable('');
    const downloadUrl = ko.observable('');
    let packId;

    const levelsToGrades = localizedResource('resource.packs.levels.to.grades');
    let level = 2;

    function determineDefaultLevel(grades) {
        const matchings = Object.map(levelsToGrades, (key, value) => value.intersect(grades).length);

        level = parseInt(Object.max(matchings), 10);
    }

    const urlMakers = {
        article(item) {
            const articleRoute = config.isActivity ?
                ActivityRoute.ACTIVITY_ARTICLE :
                PackRoute.ARTICLE;

            return `${articleRoute.replace(':packId', packId).replace(':contentId', item.contentId)}${item.tocId ? `?toc=${item.tocId}` : ''}`;
        },
        image(item) {
            const mediaRoute = config.isActivity ?
                ActivityRoute.ACTIVITY_MEDIA_OVERLAY :
                PackRoute.MEDIA_OVERLAY;

            return mediaRoute.replace(':packId', packId).replace(':contentId', item.contentId);
        },
        excerpt_article(item) {
            const excerptRoute = config.isActivity ?
                ActivityRoute.ACTIVITY_EXCERPT :
                PackRoute.EXCERPT;

            return excerptRoute.replace(':packId', packId).replace(':contentId', item.savedContentId);
        },
        excerpt_supplemental(item) {
            const excerptRoute = config.isActivity ?
                ActivityRoute.ACTIVITY_EXCERPT :
                PackRoute.EXCERPT;

            return excerptRoute.replace(':packId', packId).replace(':contentId', item.savedContentId);
        },
        ebook(item) {
            const primarySourceRoute = config.isActivity ?
                ActivityRoute.ACTIVITY_PRIMARY_SOURCE :
                PackRoute.PRIMARY_SOURCE;

            return primarySourceRoute.replace(':packId', packId).replace(':contentId', item.contentId);
        },
        supplemental(item) {
            const primarySourceRoute = config.isActivity ?
                ActivityRoute.ACTIVITY_PRIMARYSOURCE :
                PackRoute.PRIMARYSOURCE;

            return primarySourceRoute.replace(':packId', packId).replace(':contentId', item.contentId);
        },
        magazine(item) {
            const magazineRoute = config.isActivity ?
                ActivityRoute.ACTIVITY_MAGAZINE :
                PackRoute.MAGAZINE;

            return magazineRoute.replace(':packId', packId).replace(':contentId', item.contentId);
        },
        website(item) {
            if (item.additionalContentIdentifier.trim().indexOf('http') !== 0) {
                item.additionalContentIdentifier = `http://${item.additionalContentIdentifier}`;
            }

            return item.additionalContentIdentifier;
        },
        external_link(item) {
            if (item.url.trim().indexOf('http') !== 0) {
                item.url = `http://${item.url}`;
            }

            return item.url;
        },
        uploaded_document(item) {
            const indId = info().owner.individualId;
            const { originalFilename, savedContentId } = item;


            return `/${subjectPath}/custom/fetch/document/${indId}/${savedContentId}/${originalFilename}`;
        },
        full_content(typeId, item){
            console.log('full content item:', item);
            if( item.type == 'excerpt_article' || item.type == 'excerpt_supplemental'){
                return `/${subjectPath}/${packId}/activities/create/excerpt/${item.savedContentId}/${typeId}`;
            } else if (item.type == 'supplemental'){
                return `/${subjectPath}/${packId}/activities/create/primarysource/${item.contentId}/${typeId}`;
            }{
                return `/${subjectPath}/${packId}/activities/create/${item.type}/${item.contentId}/${typeId}`;
            }
        },
        create_excerpt(typeId, item){
            if( item.type == 'excerpt_article' || item.type == 'excerpt_supplemental' ){
                return `/${subjectPath}/${packId}/excerpt/${item.savedContentId}#excerpt/${typeId}`;
            } else if(item.type == 'supplemental'){
                return `/${subjectPath}/${packId}/primarysource/${item.contentId}#excerpt/${typeId}`;
            }else {
                return `/${subjectPath}/${packId}/${item.type}/${item.contentId}#excerpt/${typeId}`;
            }
        },
        preview_article(typeId, item){
            if( item.type == 'excerpt_article' || item.type == 'excerpt_supplemental' ){
                return `/${subjectPath}/${packId}/excerpt/${item.savedContentId}#/`;
            } else if(item.type == 'supplemental'){
                return `/${subjectPath}/${packId}/primarysource/${item.contentId}#/`;
            }else {
                return `/${subjectPath}/${packId}/${item.type}/${item.contentId}#/`;
            }
        }
    };

    urlMakers.video = urlMakers.image;
    urlMakers.interactive = urlMakers.image;




    // todo: refactor `urlMakers` to accommodate this

    const urlMakersForArticleId = {
        article(id) {
            const articleRoute = config.isActivity ?
                ActivityRoute.ACTIVITY_ARTICLE :
                PackRoute.ARTICLE;

            return articleRoute.replace(':packId', packId).replace(':contentId', id);
        },
    };

    function onEmailPack() {
        const actionUrl = `/${shared.getSubjectPathFromPath()}/email/pack/${packId}`;
        const $emailForm = $('#emailCriteria');

        $emailForm.uniform();
        $emailForm.submit(function () {
            if (!$(this).hasClass('failedSubmit')) {
                trackEvent({
                    eventName: 'Email - LaunchPacks',
                    eventType: 'Click on submit button in Email popover',
                });

                $.ajax({
                    url: actionUrl,
                    type: this.method,
                    data: $(this).serialize(),
                    dataType: 'json',
                    beforeSend() {
                        $('#share-pack-modal').modal('hide');
                    },
                    success(obj) {
                        $.jGrowl(obj.message, {
                            life: 3000,
                            position: 'bottom-right',
                        });
                        if (config.isTeacher()) {
                            Api.Onboarding.markFeatureComplete(OnboardingFeatureType.SHARE);
                        };
                    },
                });
            }

            else {
                trackEvent({
                    eventName: 'Email - LaunchPacks',
                    eventType: 'Incorrect completion of email Pack form',
                });
            }

            return false;
        });
    }

    function getShortUrl() {
        const destUrl = '/url/shorten';

        $.ajax({
            type: 'POST',
            url: destUrl,
            data: {
                pathToShorten: `/${shared.getSubjectPathFromPath()}/${packId}`,
            },
            success(result) {
                shortUrl(result);
                initClipboard();
            },
        });
    }

    function initClipboard() {
        const copiedText = i18n.string('packs.share.copied');
        const isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
        const couldNotCopyText = isSafari ? i18n.string('packs.share.could.not.copy.safari') : i18n.string('packs.share.could.not.copy');
        const clipboard = new Clipboard('.copy-url-btn');

        clipboard.on('success', (e) => {
            $(e.trigger).tooltip({
                placement: 'bottom',
                title: copiedText,
            }).tooltip('show');

            setTimeout(() => {
                $('#share-pack-modal').modal('hide');
                $(e.trigger).tooltip('destroy');
            }, 1000);

            e.clearSelection();

            if (config.isTeacher()) {
                Api.Onboarding.markFeatureComplete(OnboardingFeatureType.SHARE);
            }
        });

        clipboard.on('error', (e) => {
            $(e.trigger).tooltip({ placement: 'bottom', title: couldNotCopyText }).tooltip('show');
        });
    }


    const favoriteUrl = `/${subjectPath}/custom/favorite?packId={packId}`;
    const isFavorite = ko.observable(false);
    const isCustom = ko.observable(false);
    const isEbPack = ko.observable(false);

    function favorite() {
        return $.post(favoriteUrl.assign({ packId }));
    }

    function checkFavorite() {
        $.getJSON(favoriteUrl.assign({ packId })).then((response) => {
            isFavorite(!!response.result);
        });
    }

    function checkEbPack() {
        isEbPack(info().isEbPack);
    }

    //the name of this function is a misnomer as it merely checks to see if the current individual is the owner of the pack.
    //Leaving it here because it's used lots of places. To determine if something is an EB Pack or not, use checkEbPack()/isEbPack() instead.
    function checkCustom() {
        isCustom(info().owner.individualId == config.individualId);
    }

    function unFavorite() {
        return $.ajax({
            type: 'DELETE',
            url: favoriteUrl.assign({ packId }),
            dataType: 'json',
        });
    }

    function favoriteManager() {
        if (isLoggedIn()) {
            if (isFavorite()) {
                unFavorite().then((response) => {
                    isFavorite(!response.result);
                });
            }
            else {
                favorite().then((response) => {
                    isFavorite(response.result);
                });
            }
        }

        else {
            const afterLoginURL = `${window.location.protocol}//${window.location.hostname}/${shared.getSubjectPathFromPath()}/${packId}`;

            showSignInModal(afterLoginURL);
        }
    }

    function onCustomize() {
        return packDisplayShared.onCustomize(packId);
    }

    function toggleSendtoMenu(data, event) {
        event.stopPropagation();
        $('#toolbar-sendto-content').toggleClass('hidden');
        if($('#toolbar-sendto-content').hasClass('hidden')) {
            $('.tooltip').show();
            $('.btn.sendto').css('background-color', '');
            $(document).unbind('click.sendtocontent');
            $('.tool-googleclassroom').unbind('click.sendtogoogleclassroom');
        } else {
            $('.tooltip').hide();
            $('.btn.sendto').css('background-color', '#4192d1;');

            $(document).bind('click.sendtocontent', function(e){
                toggleSendtoMenu(data, e);
            });

            $('.tool-googleclassroom').bind('click.sendtogoogleclassroom', function (e) {
                $('#toolbar-sendto-content').toggleClass('hidden');
                shared.trackGaEvent(['Share To Google Classroom', 'Share Article', window.location.href]);
                window.open('https://classroom.google.com/share?url=' + encodeURIComponent(window.location.href));
            });

            //Microsoft Team
            window.shareToMicrosoftTeams.renderButtons();
            $('.tool-microsoftteam').off().on('click', function(){
                shared.trackGaEvent([
                    'Share To Microsoft Teams',
                    'Share Pack',
                    window.location.href
                ]);
                return true;
            });
        }
    }

    function markAsFavorite() {
        return favorite(packId).then(response => isFavorite(!!response.result));
    }

    function addComma(list){
        return list.join(', ');
    }

    function resetFlipCard(){
        focus(null);
        return true;
    };


    const model = {
        setFocus(model){
            // // set focus when it is not execerpt
            // if (model.type == 'excerpt_article'){
            //     // navigate to excerpt page when it is excerpt
            //  this snippets got commented out due to new feature and new routes
            //     window.location.href = urlMakers[model.type] ? urlMakers[model.type](model) : '#';

            // } else {
                focus(model);
            // }

        },
        focus,
        cancelFocus(){
            focus(null);
        },
        ActivityStrategy,
        addComma,
        afterRenderPackDisplayItems,
        favoriteManager,
        curriculumStandardsSwitch,
        packViewSwitch,
        onCustomize,
        toggleSendtoMenu,
        stripHtmlTable: PackUtils.stripHtmlTable,
        activityType,
        ActivityRoute,
        animate,
        config,
        copying,
        ebNoteVisible,
        info,
        isCustom,
        isEbPack,
        isFavorite,
        shortUrl,
        printUrl,
        printPdf,
        cancelPdf,
        cancelDownload,
        downloadPdf,
        downloadUrl,
        type,
        urlMakers,
        urlMakersForArticleId,
        userNoteVisible,
        assemblyId: ko.observable(null),
        isCtaDisabled: ko.observable(true),
        isStandardView : ko.observable(false),
        quickAssignActivity: ko.observable(new QuickAssignActivity(customPackDetail)),
        // curriculum: CurriculumStandards,
        selectedContentType: ko.observable(i18n.string('packs.type.s')),
        view: ko.observable('pinboard'),
        items: ko.computed(() => {
            if (type() == 'annotated') {
                const annotatedItems = [];

                Object.values(items()).flatten().forEach((item) => {
                    if (item.isAnnotatedContent) {
                        annotatedItems.push(item);
                    }
                });

                return annotatedItems;
            } else if (!Object.isEmpty(items())) {
                setTimeout(() => {
                    animate(false);
                }, 500);
                animate(true);

                return (type() && items()[type()]) || Object.values(items()).flatten().sortBy('order');
            }
        }),
        types: ko.computed(() => {
            const annotatedTypes = {
                key: 'annotated',
                count: 0,
                order: 1,
                icon: '',
                name: i18n.string('packs.type.annotated'),
            };

            let newTypes = [{
                key: '',
                count: Object.values(items()).flatten().length,
                order: -1,
                icon: '',
                name: i18n.string('packs.type.s'),
            }].union(Object.values(Object.map(items(), (key, value) => ({
                key,
                count: value.length,
                order: Object.keys(typeIcons).indexOf(key),
                icon: typeIcons[key],
                name: i18n.string(`packs.type.${key}s`),
            }))).sortBy('order'));

            Object.values(items()).flatten().forEach((item) => {
                if (item.isAnnotatedContent) {
                    annotatedTypes.count++;
                }
            });

            if (annotatedTypes.count > 0) {
                newTypes = newTypes.union(annotatedTypes);
            }

            return newTypes;
        }),
        onboardingCard: new OnboardingCard(),
        resetFlipCard,
    };


    // --- VM Subscriptions --- //

    // Close the activities pane when changing the filter

    /* model.selectedContentType.subscribe(() => {

        if (model.activitiesPane) {
            model.activitiesPane().closePane();
        }
    }); */


    // Other old stuff

    function initMediaGallery() {
        if (!$('.browse-marketing-card').length) {
            const baseUrl = `#/${model.view()}${type() ? `/${type()}` : ''}`;
            MediaGallery.init('.resourcepacks .pack-display .media .overlay-link[rel=media-overlay-img]', 'LaunchPacks Media Overlay', false, baseUrl);
        }
    }

    let packery = null;

    function layout() {
        setTimeout(() => {
            if (packery) {
                packery.layout();
            }
        }, 30);
    }

    const initPinboard = _.debounce(() => {
        if (packery) {
            packery.destroy();
        }

        const elem = document.querySelector('.pack-display .items');

        packery = new Packery(elem, {
            columnWidth: '.pack-display .item',
            itemSelector: '.pack-display .item',
            stamp: '.pack-display .stamp',
        });
    }, 200);

    const onItemsChange = _.debounce(() => {
        initPinboard();

        setTimeout(initMediaGallery, 50);
    }, 50);

    model.items.subscribe((v) => {
        onItemsChange();
    });

    model.type.subscribe((val) => {
        if (val == 'annotated') {
            model.selectedContentType(i18n.string('packs.type.annotated'));
        } else if (val) {
            model.selectedContentType(i18n.string(`packs.type.${val}s`));
        } else {
            model.selectedContentType(i18n.string('packs.type.s'));
        }
    });

    function getDifferentiatedPacksHtml(list) {
        if (list && Array.isArray(list) && list.length) {
            let comma = ', ',
                crossLinksOr = i18n.string('packs.header.differentiated.crosslinks.or'),
                gradesLabel = i18n.string('packs.grades');
            const htmlList = list.map((pack) => {
                const displayLabel = (pack.grade.toLowerCase().indexOf('foundation') !== -1) ? pack.grade : `${gradesLabel} ${pack.grade}`; // PAC-1032


                return `<a href="${pack.packId}">${displayLabel}</a>`;
            });


            if (list.length < 3) {
                return htmlList.join(` ${crossLinksOr} `);
            }

            htmlList[htmlList.length - 1] = `${crossLinksOr} ${htmlList[htmlList.length - 1]}`;

            return htmlList.join(comma);
        }

        return '';
    }


    const onAssemblyChange = _.debounce((id) => {
        if (mediaOverlayOpen) {
            setTimeout(() => {
                const index = $('.resourcepacks .pack-display .media a.overlay-link[rel=media-overlay-img]')
                    .index($(`.resourcepacks .pack-display .media a.overlay-link[rel=media-overlay-img][data-assembly-id="${id}"]`));

                setTimeout(() => {
                    MediaGallery.goToIndex(index);
                }, 100);
            }, 100);
        }
    }, 50);

    let assemblySubscriber = null;

    function onView(data) {
        _data = Object.clone(data, true);
        _data.packItems.each((item, index) => {
            if (item.favoriteType == 'ADDITIONALCONTENT') {
                item.type = item.additionalContentType;
            } else if (item.favoriteType == 'ASSEMBLY') {
                item.type = item.assetType;
            } else if (item.favoriteType == 'EXCERPT') {
                item.type = `${item.favoriteType}_${item.sourceContentType}`;
            } else {
                item.type = item.favoriteType;
            }

            item.type = item.type.toLowerCase();
            item.order = index;
            item.title = item.title || item.originalFilename;
        });

        if (!_.isEqual(items(), _data.packItems.groupBy('type'))) {
            items(_data.packItems.groupBy('type'));
        }

        initPinboard();

        if (_data.pack) {
            const _gradeRange = _data.pack.gradeIds && gradeRanges.find(grade => _data.pack.gradeIds.find(id => grade.value == id));

            _data.pack.gradeRange = _gradeRange && _gradeRange.fullLabel;
            _data.pack.gradeFullLabel = _data.pack.gradeRange;

            determineDefaultLevel(_data.pack.gradeIds);

            const _differentiatedPacks = Object.values(Object.map(_data.pack.differentiatedPackIdsForGradeRanges, (key, value) => ({
                grade: gradeRanges.find(grade => key == grade.value) && gradeRanges.find(grade => key == grade.value).shortLabel,
                packId: value,
            })));

            _data.pack.differentiatedPacksHtml = getDifferentiatedPacksHtml(_differentiatedPacks);

            info(_data.pack);
        }


        if (!assemblySubscriber) {
            assemblySubscriber = model.assemblyId.subscribe((id) => {
                id && onAssemblyChange(id);
            });
        }

        if (isLoggedIn()) {
            checkFavorite(packId);
            checkCustom();
        }

        checkEbPack();

        setTimeout(() => {
            onEmailPack();
            /*
            PAC-2380
             */
            // Sticky.init('.pack-display .pack-display-pinnable', 140);
        }, 300);

        getShortUrl();


        // Set `customPackDetail`

        customPackDetail(data);
    }

    const initCalendar = () => {
        CalendarModal.init();
        CalendarModal.schedulePack(info());
    };

    function init(data, id, snackType, router, assignment) {
        model.activityType(ActivityStrategy[snackType]);
        packId = id;

        // when we render the activities view, we can't mutate the rawData directly, we need to make a deep copy of it because of no-primary source
        // be filtered out when user navigate back to launch pack.
        let copyData = Object.assign({}, data);
        copyData.packItems = copyData.filteredPackItems;

        onView(copyData, router);
        cleanType(!type);
        model.assemblyId('');
        mediaOverlayOpen = false;
        getSessionVar = packDisplayShared.getSessionVar;
        setSessionVar = packDisplayShared.setSessionVar;

        initCalendar();
        getPrintUrl();
        getDownloadUrl();

        $('body').on('click', 'a[rel=noopener]', (event) => {
            const target = event.currentTarget;
            const hrefAttribute = $(target).attr('href');

            shared.writeAjaxStats(null, hrefAttribute);

            const contentId = $(target).data('contentId');


            if (contentId !== undefined) {
                const statsEvent = {
                    packId: id,
                    resourceId: contentId,
                    eventSubtype: 'resource-view',
                };

                shared.statsEvent(statsEvent);
            }

            if (target.tagName.toLowerCase() == 'a' && target.href && target.href != '#' && !target.target && !hrefAttribute.startsWith('#')) {
                event.preventDefault();
                setTimeout(() => {
                    relocateWithReferrer(target.href);
                }, 100);
            }
        });
    }

    function cleanType(clear) {
        if (clear && type()) {
            type('');
        }
    }


    // Function to run after the "pack-display-items" template renders

    function afterRenderPackDisplayItems() {
        $('[data-toggle="tooltip"]').tooltip();

        // Onboarding card
        $('.rp-onboarding-card').removeClass('hidden');
    }


    // Configure the onboarding card



    // Curriculum Standards related
    function curriculumStandardsSwitch(e) {
        model.isStandardView(true);
        window.location.hash = 'standards';

        // model.curriculumStandard.init(packId);
        // CurriculumStandards.init();
        // e.preventDefault();
    }
    function packViewSwitch(e) {
        model.isStandardView(false);
        window.location.hash = 'pinboard';
        // e.preventDefault();
    }

    function printPdf() {
        trackEvent({
            eventName: 'Print',
            eventType: 'Print Pack Button - Modal',
            eventLabel: `Print Pack Modal  - ${packId} - ${info().text}`

        });

        $.ajax({
            type: 'GET',
            url: `/${subjectPath}/custom/fetch/pack/pdf/${packId}`,
            success(result) {
                const printPage = window.open(result, '_blank');
                $('#print-pack-modal').modal('toggle');
            },
        });
    }


    function cancelPdf(){
        trackEvent({
            eventName: 'Print Pack',
            eventType: 'Print Pack Cancel - Modal',
            eventLabel: `Print Pack Cancel - ${packId} - ${info().text}`

        });

    }

    function downloadPdf(){
        trackEvent({
            eventName: 'Use Offline',
            eventType: 'Use Offline Button - Modal',
            eventLabel: `Use Offline Modal - ${packId} - ${info().text}`

        });
        $('#download-pack-modal').modal('toggle');

    }

    function cancelDownload(){
        trackEvent({
            eventName: 'Use Offline',
            eventType: 'Use Offline Cancel - Modal',
            eventLabel: `Use Offline Cancel - ${packId} - ${info().text}`

        });

    }

    function getPrintUrl(){
        $.ajax({
            type: 'GET',
            url: `/${subjectPath}/custom/fetch/pack/pdf/${packId}`,
            success(result) {
                printUrl(result);
            },
        });
    }

    function getDownloadUrl(){
        downloadUrl(`/${subjectPath}/custom/download/pack/pdf/${packId}`);
    }




    // Exports

    return {
        init,
        markAsFavorite,
        favoriteManager,
        curriculumStandardsSwitch,
        packViewSwitch,
        model,
        onView,
        toggleSendtoMenu,
        '/assembly/:id': function (view, type, id) {
            mediaOverlayOpen = true;
            model.assemblyId(id);
            cleanType(!type);
        },
        '/:type': function (view, _type) {
            _type && items()[_type] && _type != type() && type(_type);

            if (_type == 'annotated') {
                type(_type);
            }
        },
    };
}());

export default packDisplayActivitiesType;



// WEBPACK FOOTER //
// ./javascript/app/page/display/includes/activitiesType.js